import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { firestore } from "../../../helpers/firebaseConfig";

export default function useBuilderPodcastRuns(builderId) {
  const [snapshot, setSnapshot] = useState({ builderId: "", runs: [], hydrated: false });

  useEffect(() => {
    if (!builderId) {
      setSnapshot({ builderId: "", runs: [], hydrated: true });
      return undefined;
    }

    setSnapshot({ builderId, runs: [], hydrated: false });
    return onSnapshot(
      collection(firestore, "podcasts", builderId, "audio_generation", "builder", "EN"),
      (result) => setSnapshot({
        builderId,
        runs: result.docs.map((run) => ({ ...run.data(), id: run.id })),
        hydrated: true,
      }),
      (error) => {
        console.error("Failed to listen to Builder audio generation runs:", error);
        setSnapshot({ builderId, runs: [], hydrated: true });
      }
    );
  }, [builderId]);

  return snapshot.builderId === builderId
    ? { runs: snapshot.runs, hydrated: snapshot.hydrated }
    : { runs: [], hydrated: false };
}
